import { render, staticRenderFns } from "./AlarmGeneralDonutVision.vue?vue&type=template&id=124ea54e&scoped=true&"
import script from "./AlarmGeneralDonutVision.vue?vue&type=script&lang=js&"
export * from "./AlarmGeneralDonutVision.vue?vue&type=script&lang=js&"
import style0 from "./AlarmGeneralDonutVision.vue?vue&type=style&index=0&id=124ea54e&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124ea54e",
  null
  
)

export default component.exports